// ============================================================
// BRAND CONFIG – Thông tin thương hiệu hệ thống
// ============================================================

export const brandConfig = {
  name: 'Landscape OS',
  fullName: 'Landscape OS – Hệ thống Quản lý Cảnh quan',
  tagline: 'Quản lý thi công & bảo dưỡng cảnh quan chuyên nghiệp',
  version: '1.0.0',
  logo: {
    icon: 'ri-leaf-line',
    color: '#16a34a',
  },
  company: {
    name: 'QuocAnh Digital',
    address: 'TP. Hồ Chí Minh, Việt Nam',
    email: 'support@quocanhdigital.vn',
    phone: '1900 xxxx',
    website: 'https://quocanhdigital.vn',
  },
  copyright: `© ${new Date().getFullYear()} QuocAnh Digital. All rights reserved.`,
} as const;

export type BrandConfig = typeof brandConfig;
